import { useEffect } from "react";
import { IoChevronBackOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { useAmplitude } from "../../context/AmplitudeContext";
import { useUID } from "../../context/UIDContext";
import { useConfig } from "../../context/ConfigContext";
import "./styles.css";
import Button from "../Button/Button";

export const AppointmentModule = ({ onBackClick }) => {
  const { t } = useTranslation("appointmentModule");
  const trackEvent = useAmplitude();
  const { uid } = useUID();
  const { logo } = useConfig();

  useEffect(() => {
    trackEvent("webapp_user_visited_products_page", uid);
  }, [uid, trackEvent]);

  return (
    <div className="appointment-module">
      <div className="appointment-logo-bar">
        <div className="appointment-back-button-wrapper">
          <IoChevronBackOutline
            className="appointment-back-icon"
            onClick={() => onBackClick()}
          />
        </div>
        <img className="logo-img" src={logo} alt="Logo" />
      </div>
      <div className="appointment-scroll-content">
        <h4 className="appointment-title">{t("title")}</h4>
        <img
          src="appointment-faceanalyse.jpg"
          alt="face"
          width={100}
          className="appointment-face-image"
        />
        <p className="appointment-description">{t("description")}</p>
      </div>
      <div className="appointment-button">
        <Button
          text={t("book-appointment")}
          onClick={() => {
            trackEvent("webapp_user_appointment_click", uid);
            const newWindow = window.open(
              "https://www.essenzapotheken.at/beratungstermin-buchen",
              "_blank",
              "noopener,noreferrer",
            );
            if (newWindow) newWindow.opener = null;
          }}
        />
      </div>
    </div>
  );
};
